<ng-container *ngIf="meta">
  <div *ngIf="mobile else web" class="column-container full-width margin-bottom">
    <a class="product-name text-ellipsis" *ngIf="meta | linkToUrl: undefined as url"
       [routerLink]="url[0]">{{meta.name}}</a>
    <div class="row-container space-between full-width">
      <div class="row-container align-base">
        <span class="promotion-dollar">$</span>
        <span class="promotion-price">{{(meta.promotionPrice || meta.originPrice) | price}}</span>
        <span class="original-price line-through" *ngIf="meta.promotionPrice">$ {{meta.originPrice | price}}</span>
      </div>
      <button class="cart-icon" appFocusRemove *ngIf="showCart" (click)="openCart($event)">
        <app-image-loading [src]="meta.productId | cartIcon: cartModel.productIdSet()"
                           [clickable]="true"
                           [targetWidth]="17"
                           [targetHeight]="16"
                           [alt]="meta.name"/>
      </button>
    </div>
  </div>
  <ng-template #web>
    <div class="column-container full-width">
      <span class="meta-title text-ellipsis">{{meta.name}}</span>
      <div class="row-container meta-subtitle justify-center"
           [style.margin-top.px]="marginTop"
           [style.margin-bottom.px]="marginBottom">
        <span class="line-through no-wrap" *ngIf="meta.promotionPrice">NT$ {{meta.originPrice | price}}</span>
        <div class="no-wrap">
          <span class="price-margin" i18n *ngIf="meta.promotionPrice">活動價</span>
          <span>NT$ {{(meta.promotionPrice || meta.originPrice) | price}}</span>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
